export default "__VITE_ASSET__lDuhEu9e__"